import { getRole } from "./../api.js";

export const state = {
  roleResponse: {}
};

export const getters = {
  roleResponse: state => (state.roleResponse ? state.roleResponse : [])
};

export const mutations = {
  getList(state, data) {
    state.roleResponse = data.data;
  }
};

export const actions = {
  async getList({ commit }) {
    let data = await getRole();
    commit("getList", data);
  }
};
